"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../../Box"));
var ModalPortal_1 = __importDefault(require("../../Modal/ModalPortal"));
var Link_1 = __importDefault(require("../../Link"));
var SlideRightAnimation_1 = __importDefault(require("../StaggerAnimation/SlideRightAnimation"));
var config_1 = require("../config");
var MenuLink_1 = __importDefault(require("./MenuLink"));
var isActivePath_1 = require("../../utils/isActivePath");
var IconButton_1 = __importDefault(require("../../IconButton"));
var react_use_1 = require("react-use");
function Drawer(props) {
    var colorTheme = props.colorTheme, navLinks = props.navLinks, open = props.open, onClose = props.onClose, zIndex = props.zIndex;
    var _a = (0, react_1.useState)(false), animationOpen = _a[0], setAnimationOpen = _a[1];
    (0, react_use_1.useKeyPressEvent)('Escape', function () {
        handleClose();
    });
    (0, react_1.useEffect)(function () {
        // ---- relation of open and animationOpen ----
        if (open) {
            setTimeout(function () {
                setAnimationOpen(true);
            }, 50);
        }
    }, [open]);
    var handleClose = function () {
        setAnimationOpen(false);
        setTimeout(function () {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }, config_1.DESK_ANIMATION_TIME); // close after animation
    };
    return (react_1.default.createElement(ModalPortal_1.default, null,
        react_1.default.createElement(Backdrop, { open: animationOpen, onClick: handleClose },
            react_1.default.createElement(DrawerContainer, { colorTheme: colorTheme, open: animationOpen, zIndex: zIndex, onClick: function (event) {
                    // prevent click propagation to backdrop
                    event.stopPropagation();
                } },
                react_1.default.createElement(react_focus_lock_1.default, { disabled: !open, group: 'header2' },
                    react_1.default.createElement(Box_1.default, { textAlign: 'right' },
                        react_1.default.createElement(CloseButton, { "aria-label": 'close menu', icon: 'ff-icon-cross', iconProps: {
                                fontSize: '16px',
                                color: colorTheme === 'DARK' ? 'white' : 'black'
                            }, onClick: handleClose })),
                    react_1.default.createElement(Content, null,
                        react_1.default.createElement(RootMenuSection, null,
                            react_1.default.createElement(DrawerList, { role: 'listbox' },
                                react_1.default.createElement(SlideRightAnimation_1.default, { start: animationOpen }, navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (item) { return (react_1.default.createElement(MenuLink_1.default, { role: 'option', key: item.label, active: (0, isActivePath_1.isActivePath)(item.url), colorTheme: colorTheme },
                                    react_1.default.createElement(Link_1.default, { "data-event-label": item.label, "data-event-location": 'drawer_menu', href: item.url }, item.label))); }))))))))));
}
exports.default = Drawer;
var Backdrop = (0, styled_1.default)(Box_1.default)(function (_a) {
    var open = _a.open, theme = _a.theme;
    return ({
        position: 'fixed',
        top: 0,
        backgroundColor: theme.colors.modalBackdrop,
        zIndex: 1000,
        width: open ? '100vw' : 0,
        height: '100vh',
    });
});
var DrawerContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme, open = _a.open, colorTheme = _a.colorTheme, zIndex = _a.zIndex;
    return ({
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        backdropFilter: 'blur(5px)',
        zIndex: zIndex === undefined ? theme.zIndices.menubarDrawer : zIndex,
        backgroundColor: colorTheme === 'DARK' ? 'rgba(12, 13, 15, 0.9)' : theme.colors.white,
        color: colorTheme === 'DARK' ? 'rgba(255, 255, 255, 0.8)' : theme.colors.text,
        padding: '50px 32px',
        overflowY: 'auto',
        height: '100vh',
        // hide scroll bar during animation
        overflowX: 'hidden',
        // animation
        transitionDuration: config_1.DESK_ANIMATION_TIME + "ms",
        transitionProperty: 'transform, opacity',
        transitionTimingFunction: 'ease-in-out',
        transform: open ? 'translateX(0%)' : 'translateX(-30%)',
        opacity: open ? 1 : 0,
        width: config_1.layout.desktopNavWidth,
        boxShadow: theme.boxShadows.drawer,
    });
});
var DrawerList = (0, styled_1.default)(Box_1.default)({
    position: 'relative',
});
DrawerList.defaultProps = { as: 'ul' };
var DrawerSubnavList = (0, styled_1.default)(Box_1.default)({
    position: 'absolute',
    left: '100%',
    top: 0,
    listStyleType: 'none'
});
DrawerSubnavList.defaultProps = { as: 'ul' };
var CloseButton = (0, styled_1.default)(IconButton_1.default)({
    alignSelf: 'flex-end',
    marginBottom: '50px',
    backgroundColor: 'rgba(116, 116, 128, 0.18)',
    height: '30px',
    width: '30px',
    borderRadius: '30px'
});
var RootMenuSection = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
});
var Content = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    justifyContent: 'space-between',
});
Content.defaultProps = { as: 'nav' };
